import { useMemo } from "react";
import { find, map } from "lodash";
import { getPlatformColor } from "@linkfluence/models/platform";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import {
  InfluencerLensFactory,
  SearchableInfluencer,
} from "@radarly/models/influencer";
import {
  getCountFromSort,
  getMetricFromSort,
} from "@radarly/models/influencer/generic";
import { SearchFragmentUsers } from "@radarly/models/search";
import { useRangeFromFragment } from "./useRangeFromFragment";

export function useHorizontalBarChartAuthorsWidget(
  data: SearchFragmentUsers["data"],
  fragment: SearchFragmentUsers,
  dataviz: DatavizHorizontalBarChart,
  onClickAuthor: (author: SearchableInfluencer) => void
) {
  const locale = useCurrentUserLocale();
  const sort = fragment.request.aggs.users.sort.on;

  const range = useRangeFromFragment(fragment, false);
  const gauges = useMemo(() => {
    return map(data ? data.aggs.users.values : [], (influencer) => {
      const influencerLens = InfluencerLensFactory.create(influencer.user);
      return {
        id: influencerLens.getUID(),
        count: getCountFromSort(influencer, sort),
        label: influencerLens.getName(),
        color: getPlatformColor(influencer.user.platform),
        avatar: influencerLens.getAvatar(),
      };
    });
  }, [data, sort]);
  const onClickGauge = (uid: string | number) => {
    const findedInfluencer = find(data.aggs.users.values, (influencer) => {
      return InfluencerLensFactory.create(influencer.user).getUID() === uid;
    });
    if (findedInfluencer) {
      onClickAuthor(findedInfluencer);
    }
  };
  return {
    range,
    locale,
    gauges,
    limit: 5,
    mainUnit: "total" as const,
    secondaryValue: "none" as const,
    sort: dataviz.sort === "mainUnit" ? ("mainValue" as const) : dataviz.sort,
    order: "desc" as const,
    metric: getMetricFromSort(sort),
    onClickGauge: onClickAuthor ? onClickGauge : null,
    color: dataviz.color,
  };
}
